import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const SubscriptionListModel = types
  .model("SubscriptionListModel", {
    subscriptions: types.array(
      types.model("SubscriptionList", {
        sku: types.string,
        name: types.string,
        price: types.number,
        currency: types.string,
        active: types.boolean,
        tenure: types.string,
        productCode: types.string,
        description: types.string,
        isbns: types.array(types.string),
        vetIsbns: types.array(types.string),
      })
    ),
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("FETCHING_SUBSCRIPTION_LIST");
    },
    set(response) {
      const subscriptions = response.data.response;
      applySnapshot(self, {
        subscriptions,
      });
    },
  }));

export default SubscriptionListModel;